module.exports = __webpack_public_path__ + "static/media/chevron-double-down.b70c77bf.svg";